import { TimeSpentEntry } from "@/types/timeSpentAsValue"
import moment from "moment"

export const formatDateMixin = {
	methods: {
		dateStringWithZeroHourOffset (value: Date) {
			return value ? moment(value + "Z") : ""
		},
		displayDateFromISOString (value: Date) {
			return value ? moment(value).format("L LT") : ""
		},
		displayDateOnlyFromISOString (value: Date) {
			return value ? moment(value).format("L") : ""
		},
		displayUtcDateOnlyFromISOString (value: Date) {
			return value ? moment.utc(value).format("L") : ""
		},
		convertUtcDateTimeToLocalDateTimeString (value: Date) {
			return value ? moment(value + "Z").format("L LT") : ""
		},
		convertUtcDateTimeToLocalTimeString (value: Date) {
			return value ? moment(value + "Z").format("LT") : ""
		},
		fromNow (value: Date) {
			return value ? moment(value + "Z").fromNow() : ""
		},
		isoFromNow (value: Date) {
			return value ? moment(value).fromNow() : ""
		},
		displayUnParkAt (value?: Date) {
			return value ? moment(value + "Z").format("L LT") : null
		},
		currentDateFormatted () {
			return moment().format()
		},
		endOFDayFormatted () {
			return moment()
				.endOf("day")
				.format()
		},
		weekAgoDateFormatted () {
			return moment()
				.subtract(7, "days")
				.format()
		},
		toStartOfDay (value: string) {
			return moment(value)
				.startOf("day")
				.format()
		},
		toEndOfDay (value: string) {
			return moment(value)
				.endOf("day")
				.format()
		},
		relativeDaysDateFormatted (days: number) {
			days = days === undefined ? 7 : days
			return moment()
				.subtract(days, "days")
				.format("YYYY-MM-DDTHH:mm:ss.000")
		},
		formatDateStr (dateStr: string, timeOnly = false, convertFromUTC = false, includePeriod = true, dateOnly = false) {
			if (dateStr) {
				if (convertFromUTC && !dateStr.includes("Z")) {
					dateStr += "Z"
				}

				const date = new Date(dateStr)

				const monthNames = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"]

				const day = date.getDate()
				const monthIndex = date.getMonth()
				const year = date.getFullYear()
				const hours = date.getHours()
				const mins = date.getMinutes()

				let formattedDate = ""

				if (!timeOnly) {
					formattedDate += day + " " + monthNames[monthIndex] + " " + year
				}

				if (!dateOnly) {
					formattedDate += " " + (hours < 10 ? "0" : "") + hours + ":" + (mins < 10 ? "0" : "") +
						mins + " " + (includePeriod ? (hours < 12 ? "am" : "pm") : "")
				}
				return formattedDate.trim()
			}
		},
		timeSpentFormatted (hoursSpent: number): string {
			const days = Math.floor(hoursSpent / 24)
			const hours = Math.floor(hoursSpent % 24)
			const minutes = Math.floor((hoursSpent % 1) * 60)

			let formattedString = ""
			if (days >= 1) {
				formattedString += `${days} day${days > 1 ? "s" : ""}`
			}
			if (hours >= 1) {
				if (days >= 1) {
					formattedString += ", "
				}
				formattedString += `${hours} hour${hours > 1 ? "s" : ""}`
			}

			if (days >= 1) {
				return formattedString
			}

			if (minutes >= 1) {
				if (hours >= 1) {
					formattedString += ", "
				}
				formattedString += `${minutes} minute${minutes > 1 ? "s" : ""}`
				return formattedString
			}

			if (hours > 0) {
				return formattedString
			}

			return "Under 1 minute"
		}
	}
}

export const stringMixin = {
	methods: {
		isNullOrWhitespace (input: string) {
			return !input || !input.trim()
		}
	}
}
